/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Common_ReleasedInputs */

const en_wc_common_released = /** @type {(inputs: Wc_Common_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`released`)
};

/**
* | output |
* | --- |
* | "released" |
*
* @param {Wc_Common_ReleasedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_common_released = /** @type {((inputs?: Wc_Common_ReleasedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Common_ReleasedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_common_released(inputs)
});
export { wc_common_released as "wc.common.released" }